module.exports = __webpack_public_path__ + "img/p3-p2-text.4c2e9062.png";